import type { Ref } from 'vue';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { createGlobalState, useLocalStorage } from '@vueuse/core';
// import type { HistoryRowData, NavMenuItem, NAV_MENU_TYPE } from '../types';
import type { NavMenuItem, NAV_MENU_TYPE } from '../types';
// import { getHistoryList } from '../api';
// import { getHistoryRouterData } from '../utils/history-router';
// import { flatMap } from 'lodash-es';

export const NAVBAR_COLLAPSED_STORAGE_KEY = 'agentic:navbar:isCollapsed';

// TODO: 迁移到公用组件库时需要移除 @eureka 依赖
// import { create } from '@eureka/utils/deferred';

/**
 * 创建一个延迟对象（替代 @eureka/utils/deferred）
 */
// function create<T>(): { promise: Promise<T>; resolve: (value: T) => void; reject: (reason?: any) => void } {
//     let resolve!: (value: T) => void;
//     let reject!: (reason?: any) => void;
//     const promise = new Promise<T>((res, rej) => {
//         resolve = res;
//         reject = rej;
//     });
//     return { promise, resolve, reject };
// }

export const useNavBarState = createGlobalState(
    () => {
        const isCollapsed = useLocalStorage(NAVBAR_COLLAPSED_STORAGE_KEY, false, { writeDefaults: false });
        const opened = computed({
            get: () => !isCollapsed.value,
            set: value => {
                isCollapsed.value = !value;
            },
        });

        const loading = ref(true);

        const route = useRoute();

        // const listDeferred = create<NavMenuItem[]>();

        const historyList: Ref<NavMenuItem[]> = ref([]);

        // 高亮状态管理
        const activeMenuType = ref<NAV_MENU_TYPE | string | null>(null);
        const activeMenuId = ref<string | null>(null);
        // 是否由外部控制高亮状态
        const controlled = ref(false);

        const currentDetailId = computed(() => {
            return route.params?.seek_id || route.params?.board_id || route.params?.projectId || route.params?.fmea_id || route.query?.board_id || route.params?.taskId || route.params?.id || route.params?.agent_job_id || route.params?.lsAgentId || route.params?.graph_id || route.params?.triz_mind_id;
        });

        /**
         * 设置当前高亮的菜单类型
         * @param type 菜单类型
         * @param id 菜单ID（可选，用于历史记录）
         */
        function setActiveMenuType(type: NAV_MENU_TYPE | string | null, id?: string | null) {
            activeMenuType.value = type;
            activeMenuId.value = id || null;
            controlled.value = true; // 标记为由外部控制
        }

        /**
         * 清除高亮状态
         */
        function clearActiveMenuType() {
            activeMenuType.value = null;
            activeMenuId.value = null;
            controlled.value = false; // 交由路由/默认匹配
        }

        function updateHistory(list: NavMenuItem[]) {
            historyList.value = list;
        }

        /**
         * 检查历史记录是否高亮
         */
        function checkHistoryActive(type: string, id: string): boolean {
            // 如果由外部控制，优先匹配 ID，再匹配 type
            if (controlled.value) {
                // 如果设置了 activeMenuId，优先匹配 ID
                if (activeMenuId.value) {
                    return id === activeMenuId.value;
                }
                // 否则匹配 type
                return type === activeMenuType.value;
            }
            // 否则匹配 ID 或 type
            return id === currentDetailId.value || type === activeMenuType.value;
        }

        /**
         * 查询历史记录列表
         * TODO: 暂时不调用，迁移到公用组件库时需要移除 @eureka 依赖
         */
        function queryList() {
            // getHistoryList().then((res) => {
            //     const data = flatMap(res.history_maps, 'data') as HistoryRowData[]
            //     historyList.value = data.map(item => {
            //         const { router, module } = getHistoryRouterData(item.source, item.id);
            //         return {
            //             type: item.source,
            //             id: item.id,
            //             title: item.message,
            //             link: item.link,
            //             router,
            //             module,
            //             icon_url: item.icon_url,
            //             business_name: item.business_name,
            //             active: checkHistoryActive(item.source, item.id),
            //         }
            //     })
            //     listDeferred.resolve(historyList.value)
            //     loading.value = false;
            // });
            // 暂时跳过历史记录加载
            loading.value = false;
        }

        // 监听 ID 变化或手动设置的高亮类型
        watch([currentDetailId, activeMenuType, activeMenuId], () => {
            historyList.value = historyList.value.map(item => ({
                ...item,
                active: checkHistoryActive(item.type, item.id || ''),
            }));
        });

        return {
            opened,
            loading,
            historyList,
            currentDetailId,
            activeMenuType,
            controlled,
            setActiveMenuType,
            clearActiveMenuType,
            queryList,
            updateHistory,
        };
    },
);
